<template>
   <div class="divider">
   </div>


</template>

<script>


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.divider {
   border:1px solid rgba(0, 0, 0, 0.087);
}
</style>
